module.exports = __webpack_public_path__ + "img/cases-brand-11-cover.39251a01.png";